import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface receiptVoucher {
    id: number;
    voucher_no: string;
    client_id: number;
    client_name: string;
    order_id: number;
    order_no: string;
    date: string;
    value: number;
    paragraph: string;

}
interface iReceiptVouchers {
 [key:number]:receiptVoucher[]
}
// Receipt vouchers state
export interface receiptVouchersState {
    isLoaded: boolean, // First load
    isLoading: boolean, // On filtering laoder
    isFetching: boolean,
    hasMore: boolean,
    receiptVouchers: iReceiptVouchers,
    page:number
}

const initialReceiptVouchersState: receiptVouchersState = {
    isLoaded: false,
    isLoading: false,
    isFetching: false,
    hasMore: true,
    receiptVouchers: {},
    page:1
}

// Receipt vouchers slice
export const receiptVouchersSlice = createSlice({
    name: 'receipt_vouchers',
    initialState: initialReceiptVouchersState,
    reducers: {
        init: ( state, {payload}: PayloadAction<receiptVoucher[]> ) => {
            state.receiptVouchers[state.page] = payload
        },
        setIsLoaded: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoaded = payload
        },
        setIsLoading: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoading = payload
        },
        setIsFetching: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isFetching = payload
        },
        setHasMore: ( state, {payload}: PayloadAction<boolean> ) => {
            state.hasMore = payload
        },
        addReceiptVouchers: ( state, {payload}: PayloadAction<receiptVoucher[]> ) => {
            state.receiptVouchers[state.page] =   state.receiptVouchers[state.page]?
             [...state.receiptVouchers[state.page],...payload ]:[...payload]
        },
        updateReceiptVoucher: ( state, {payload}: PayloadAction<receiptVoucher> ) => {
            let index = state.receiptVouchers[state.page].findIndex( receiptVoucher => receiptVoucher.id === payload.id )
            if( index !== -1 )
                state.receiptVouchers[state.page][index]=payload
        },
        deleteReceiptVouchers: ( state, {payload}: PayloadAction<number[]> ) => {
            payload.map(id => {
                let index = state.receiptVouchers[state.page].findIndex( receiptVoucher => receiptVoucher.id === id )
                if( index != -1 )
                    state.receiptVouchers[state.page].splice( index, 1 )
            })
        },
        reset: ( state ) => {
            state.receiptVouchers = []
            state.hasMore = true
        },
        setPage:(state,{payload}:PayloadAction<number>)=>{
            state.page=payload
        }
    }
})